
















































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { SuketSehatJiwaMmpiInterface } from "@/types/suket_sehat_jiwa_mmpi";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import SuketSehatJiwaMmpi from "@/services/SuketSehatJiwaMmpi";
import StoreSuketSehatJiwaMmpi from "@/store/modules/SuketSehatJiwaMmpi";
import { storeDokter } from "@/store/modules/dokter";

@Component({
  components: {
    CardModalTtd,
  },
})
export default class SuketSehatJiwaMmpiInputCard extends Vue {
  @Prop() readonly register!: string;
  @Prop() dataSuket!: SuketSehatJiwaMmpiInterface;

  register_id = this.dataSuket?.register_id || this.register;
  pasien_rm = this.dataSuket?.pasien_rm || this.pasien.rm;
  unit_id = this.dataSuket?.unit_id || this.user.unit_id;
  nama = this.pasien.nama;
  umur =
    this.dataSuket?.pasien.umur ||
    getAge(formatDMYDate(this.pasien.tgl_lahir)).toString().concat(" Th");
  pekerjaan = this.pasien.pekerjaan;
  // alamat = this.dataSuket?.content.alamat || this.pasien.alamat;
  keadaan = this.dataSuket?.content.keadaan || null;
  sikap_terhadap_tes = this.dataSuket?.content.hasil.sikap_terhadap_tes || null;
  indeks_kapasitas_mental =
    this.dataSuket?.content.hasil.indeks_kapasitas_mental || null;
  profil_klinis = this.dataSuket?.content.hasil.profil_klinis || null;
  indeks_kepribadian_dasar =
    this.dataSuket?.content.hasil.indeks_kepribadian_dasar || null;
  kesimpulan = this.dataSuket?.content.hasil.kesimpulan || null;
  kegunaan = this.dataSuket?.content.kegunaan || null;
  surat_date = this.dataSuket?.surat_date || new Date();
  signee_user_id = this.dataSuket?.signee_user_id || this.user.id;
  creator_user_id = this.dataSuket?.creator_user_id || this.user.id;
  alamat_type = "ktp";

  validasi = [(v) => !!v || "*Kolom ini harus diisi"];
  modalTtdSkJiwa = false;
  saving = false;

  valPemeriksaanNormal = false;
  showInputTujuan = true;
  indeksOptions = [
    {
      id: 1,
      name: "Sangat Buruk",
    },
    {
      id: 2,
      name: "Buruk",
    },
    {
      id: 3,
      name: "Sedang",
    },
    {
      id: 4,
      name: "Baik",
    },
    {
      id: 5,
      name: "Sangat Baik",
    },
  ];
  keadaanOptions = [
    {
      id: 1,
      name: "Sehat Jiwa",
    },
    {
      id: 2,
      name: "Tidak Sehat Jiwa",
    },
  ];

  get pasien() {
    return storePasien.identitasPasien;
  }

  get alamatOptions() {
    const opts = [
      {
        id: "ktp",
        name: this.pasien.alamat,
        category: "Alamat KTP",
      },
    ];

    if (this.pasien.alamat_domisili) {
      opts.push({
        id: "domisili",
        name: this.pasien.alamat_domisili,
        category: "Alamat Domisili",
      });
    }

    return opts;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        alamat_type: this.alamat_type,
        keadaan: this.keadaan,
        hasil: {
          sikap_terhadap_tes: this.sikap_terhadap_tes,
          indeks_kapasitas_mental: this.indeks_kapasitas_mental,
          profil_klinis: this.profil_klinis,
          indeks_kepribadian_dasar: this.indeks_kepribadian_dasar,
          kesimpulan: this.kesimpulan,
        },
        kegunaan: this.kegunaan,
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id,
    };
  }

  get listDokter() {
    return storeDokter.list;
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  passTtd(value) {
    this.$emit("passTtd", value);
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      const action = this.dataSuket
        ? SuketSehatJiwaMmpi.update(this.dataSuket.id, this.input)
        : SuketSehatJiwaMmpi.create(this.input);

      action
        .then(() => {
          if (this.canSign) {
            this.$emit("showSignatureModal");
          }

          appModule.NoticeDelay("Berhasil Simpan");

          this.close();
          StoreSuketSehatJiwaMmpi.getSuketByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.$emit("close");
  }
}
